import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { IMAGE_ADDRESS } from '../../../../apis';
import { handleChangeDataCategories } from '../../../../redux/actions/categories';
import 'swiper/css';
import { LazyLoadImage } from "react-lazy-load-image-component";
import LogoTypography from '../../../../styles/images/brand/typography.svg';


const CategoriesMobile = () => {

	const dispatch = useDispatch();


	const { categories } = useSelector(state => state.categories);
	const firstLvlSelected = categories?.find(category => category.isSelect) ?? categories[0];
	const secondLvlExpanded = firstLvlSelected?.children?.find(category => category.isExpand) ?? null;
	

	const handleClickFirstLvl = (lvl1Id) => {
		const newCategories = [...categories];
		newCategories.map((cat, index) => {
			cat.isSelect = cat.id == lvl1Id;
		});
		dispatch(handleChangeDataCategories('categories', newCategories));
	};

	const handleCollapse = (lvl2Id) => {
		const newCategories = [...categories];
		// const newCategories = categories;
		const firstCats = newCategories.find(category => category.id === firstLvlSelected.id);
		const secondCats = firstCats.children.find(category => category.id == lvl2Id);

		secondCats.isExpand = !secondCats.isExpand;
		dispatch(handleChangeDataCategories('categories', newCategories));
	};



    return (

    	<div className="flex flex-col grow">

    		<div className="sticky top-0 left-0 w-full z-3 bg-neutral-000" style={{top: '0'}}>
    			<div>
					<header className="px-4 lg:py-2 py-3 relative flex items-start z-5 bg-neutral-000 shadow-none shadow-1-bottom">
						<div className="relative ml-0 w-full">
							<div className="w-full">
								<div>
									<div className="flex justify-between items-center">
										<div className="flex-1 BaseLayoutSearch_BaseLayoutSearch__QHPTB">
											<div data-cro-id="searchbox-click" className="flex items-center SearchInput_SearchInput__HB9qi SearchInput_SearchInput__searchInput__CEpaj ellipsis rounded-md bg-neutral-100 h-10 border-none bg-neutral-100 grow px-0 lg:px-4 text-body-2">
												<div className="w-full rounded-full !rounded-md">
													<div className="flex items-center justify-between grow min-w-0 h-9 px-3">
														<div className="flex cursor-pointer">
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																<use xlinkHref="#searchSearch"></use>
															</svg>
														</div>
														<span data-cro-id="searchbox-type" className="grow px-2 lg:px-4 h-10 ellipsis">
															<div className="lg:text-body-2 text-button-1 flex items-center h-full text-body-2 text-neutral-500">
																<div className="flex gap-1 items-center">
																	<span className="lg:text-subtitle text-button-1 text-neutral-500 opacity-70">جستجو در
																	</span>
																	<div style={{width: '61px', height: '16px', lineHeight: '0'}}>
																		<LazyLoadImage className="w-full inline-block" src={LogoTypography} width="61" height="16" alt="کوچی" title="" style={{objectFit: 'contain'}} />
																	</div>
																</div>
															</div>
															<div className="absolute top-2 right-13 flex">
															</div>
														</span>
														<div className="flex cursor-pointer">
															<div className="cube-font-icon" data-icon-name="cube-action-ai-photo" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-ai-500)'}}>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o !right-6 !top-[-2px] styles_Tooltip__tooltip__arrow--bottom__rZ4eR styles_Tooltip__tooltip--hasArrow___6xzR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom" style={{position: 'absolute', inset: '0px auto auto 0px', transform: 'translate3d(230px, 87px, 0px)'}}>
									<div className="flex items-center">
										<span>ویژگی‌های محصولت رو توصیف کن، مثل رنگ و جنس تا پیداش کنیم.
										</span>
										<div className="flex cursor-pointer">
											<div className="cube-font-icon" data-icon-name="cube-nav-close" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-white)'}}>
											</div>
										</div>
									</div>
									<div>
									</div>
								</div>
							</div>
						</div>
					</header>
				</div>
    		</div>




    		<div className="sticky top-0 left-0 w-full z-3 bg-neutral-000" id="base_layout_mobile_sticky_header" style={{top: '0px'}}>
				<div className="grow flex flex-col" style={{paddingBottom: '55px', paddingTop: '0px'}}>
					<div className="styles_BaseLayoutMobile__fixMobileHeader__eilSC">
						<div id="base_layout_mobile_static_header">
						</div>
					</div>
					<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX">
						<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
						</div>
						<div className="flex h-full overflow-hidden children:overscroll-none styles_content__Ekd9W">
							<div className="bg-neutral-100 shrink-0 overflow-y-auto hide-scrollbar styles_mainMenuItemsContainer__sp1zS">
								{
									categories.map((catLvl1, lvl1Key) => (
										<div key={lvl1Key} onClick={() => handleClickFirstLvl(catLvl1.id)} data-cro-id="MegaMenu-category" className={`flex flex-col items-center py-3 px-2 border-complete-b-200 ${catLvl1.id === firstLvlSelected?.id ? 'bg-neutral-000 styles_mainMenuItem--active__3BT4l' : 'bg-neutral-100 border-complete-l-200'}`}>
											<div className="flex mb-1">
												<LazyLoadImage alt={catLvl1.title} src={IMAGE_ADDRESS + catLvl1.icon} style={{width: '16px', height: '16px', fill: `${catLvl1.id === firstLvlSelected?.id ? 'var(--color-icon-primary)' : 'var(--color-icon-high-emphasis)'}`}} />
												{/*<svg style={{width: '16px', height: '16px', fill: `${catLvl1.id === firstLvlSelected?.id ? 'var(--color-icon-primary)' : 'var(--color-icon-high-emphasis)'}`}}>
													<use xlinkHref="#mobile"></use>
												</svg>*/}
											</div>
											<span className={`text-caption text-center ${lvl1Key === 0 ? 'text-primary-500' : 'text-neutral-700'} `}>{catLvl1.title}
											</span>
										</div>
									))
								}
							</div>
							<div className="grow mr-2 overflow-y-auto hide-scrollbar">
								<div className="grow flex-col items-stretch px-2 flex">
									<Link className="styles_Link__RMyqc" data-cro-id="mega-menu-all-cat" to={`/category/${firstLvlSelected?.url}`}>
										<div className="break-words py-3">
											<div className="flex items-center grow">
												<p className="grow text-body2-strong text-secondary-700">
													<span className="relative">همه محصولات {firstLvlSelected?.title}
													</span>
												</p>
												<div className="flex mr-2 shrink-0">
													<svg style={{width: '18px', height: '18px', fill: 'var(--color-secondary-700)'}}>
														<use xlinkHref="#chevronLeft"></use>
													</svg>
												</div>
											</div>
										</div>
									</Link>
									{
										firstLvlSelected?.children.map((catLvl2, lvl2Key) => {
											return catLvl2.children.length > 0 ? (
												<div key={lvl2Key} className="text-body1-strong border-complete-b" data-cro-id="mega-menu-parent">
													<div className="break-words py-3 py-2 text-body1-strong text-neutral-900" onClick={() => handleCollapse(catLvl2.id)}>
														<div className="flex items-center grow">
															<p className="grow cursor-pointer">
																<span className="relative">{catLvl2.title}
																</span>
															</p>
															<div className="flex mr-2 shrink-0">
																<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																	<use xlinkHref={`${catLvl2.id === secondLvlExpanded?.id ? '#chevronUp' : '#chevronDown'}`}></use>
																</svg>
															</div>
														</div>
													</div>
													{ catLvl2.id === secondLvlExpanded?.id &&
														<div class="text-caption text-neutral-700">
															<div class="grid grid-cols-3 flex-wrap">
																{ 
																	secondLvlExpanded.children.map((thirdLvlCat, Lvl3Key) => (
																		<Link to={`/category/${thirdLvlCat.url}`} class="flex flex-col items-center p-2 text-caption text-neutral-900 text-center" data-cro-id="mega-menu-leaf" >
																			<div class="relative flex items-center justify-center bg-neutral-100 mb-2 rounded-circle styles_categoryItemImage__cAg5_">
																				<div style={{width: '45px', height: '45px', lineHeight: '0'}}>
																					<LazyLoadImage class="w-full styles_image__5lulR inline-block" src={IMAGE_ADDRESS + thirdLvlCat.icon} width="45" height="45" alt={thirdLvlCat.title} title="" style={{objectFit: 'contain'}} />
																				</div>
																			</div>{thirdLvlCat.title} 
																		</Link>
																	))
																}
															</div>
														</div>
													}
												</div>
											) : (
												<Link key={lvl2Key} className="w-full" to={`/${catLvl2.url}`}>
													<div className="break-words py-3 border-complete-b">
														<div className="flex items-center grow">
															<p className="grow text-body1-strong text-neutral-900">
																<span className="relative">{catLvl2.title}
																</span>
															</p>
														</div>
													</div>
												</Link>
											);
										})
									}

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>



		</div>

    );
}

export default CategoriesMobile;